import Vue from 'vue';
import {API_ROOT} from '../config'

export default Vue.resource(API_ROOT + 'invoice-data', {});



// WEBPACK FOOTER //
// ./client/resources/invoiceDataResource.js